import { useEffect } from 'react';

import { commentGetListAction } from '@/Module/Comment/Store/Action';
import { commentSelectIds } from '@/Module/Comment/Store/Selector';
import { useAppDispatch, useAppSelector } from '@/Module/Store/Hook';

export const useCommentList = () => {
  const dispatch = useAppDispatch();
  const page = useAppSelector(state => state.comment.page);
  const isLoading = useAppSelector(state => state.comment.isLoading);
  const commentIds = useAppSelector(commentSelectIds);
  const selectedLessonSectionId = useAppSelector(state => state.lessonSection.selectedLessonSectionId);

  useEffect(() => {
    if (!selectedLessonSectionId) return () => {};

    const promise = dispatch(
      commentGetListAction({
        typeId: 3,
        entityId: selectedLessonSectionId,
      }),
    );

    return () => {
      promise.abort();
    };
  }, [page, selectedLessonSectionId]);

  return {
    isLoading,
    commentIds,
  };
};
